export default "__VITE_ASSET__DOyXLlnQ__"